import { createSlice } from "@reduxjs/toolkit";
import { ADD_UPDATE_CUSTOMER } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import useRequireAuth from "../../utils/useRequireAuth";

const customerSlice = createSlice({
  name: "Customer",
  initialState: {
    successMessage: null, // Move successMessage to state
  },
  reducers: {
    addCustomerSuccess: (state, action) => {
      state.successMessage = action.payload;
    },
    addCustomerFailure: (state, action) => {
      state.successMessage = `Error: ${action.payload}`;
    },
    removeCustomer: (state, action) => {
      localStorage.removeItem("myUserData");
      state.successMessage = null;
    },
    updateCustomer: (state, action) => {
      const addUserData = action.payload;
      localStorage.setItem("myUserData", JSON.stringify(addUserData));
      state.successMessage = null;
    },
    getCustomerId: (state, action) => {
      const addCompanyData = action.payload;
      localStorage.setItem("company_data", JSON.stringify(addCompanyData));
      state.successMessage = null;
    },
  },
});

export const { addCustomerSuccess, addCustomerFailure, removeCustomer, updateCustomer, getCustomerId } =
  customerSlice.actions;

export const addCustomer = (userData) => async (dispatch) => {};

export default customerSlice.reducer;
